import React, { Suspense, useEffect, useMemo, useRef, useState } from "react";
import { ApproveCriteriaData } from "./data/ApproveCriteria.data";
import DataLoader from "../../../components/ui/dataLoader/DataLoader";
import Accordion from "../../../components/Accordion/Accordion";
import FormCreator from "../../../components/Forms/FormCreator";
import Buttons from "../../../components/ui/button/Buttons";
import { useNavigate, useParams } from "react-router-dom";
import { useApproveSGBPCriteriaByIdMutation, useDDownloadProductCertificationAssessmentCritreriaMutation, useGetAllRequirementListForSectionAMutation, useGetAllRequirementListForSectionBMutation, useGetAllRequirementListForSectionCMutation, useLazyGetAllDropdownForCRUDCategoryQuery, useLazyGetSGBPCriteriaDetailsByIdQuery, useUpdateCriteriaDetailsMutation } from "../../../app/services/Crud/crudApi";
import { decryptAESID } from "../../../utils/Encryption";
import { getAuthProps } from "../../../lib/authenticationLibrary";
import SwalAlert from "../../../services/swalService/SwalService";
import { setAllDropDownField } from "./utils/dropdownUtils";
import { saveAs } from 'file-saver'



const Section = ({ 
  
  title,
   data,
   searchText,
   handleSearch,
   renderList,
   listRefs,
   handleAssign,
   handleUnassign
  
  }) => (
  <div className="requirement-section">
    <div className="req-box">
      <h4 className="section-title">{title}</h4>
      <p className="sub-title">Approved Requirements</p>
      <div className="list-box">
        <input
          type="text"
          placeholder="Search"
          className="search"
          value={searchText[title]?.approved}
          onChange={(e) => handleSearch(title, "approved", e.target.value)}
        />
        {/* <ul>{renderList(title, "approved", data?.approved)}</ul> */}
        <ul ref={(el) => { if (el) listRefs.current[`${title}-approved`] = el; }}>
          {renderList(title, "approved", data?.approved)}
        </ul>
      </div>
    </div>

    <div className="action-buttons">
      <Buttons buttonText="Assign ›" buttonTypeClassName="assign-btn" onClick={() => handleAssign(title)} />
      <Buttons buttonText="‹ Unassign" buttonTypeClassName="unassign-btn" onClick={() => handleUnassign(title)} />
    </div>

    <div className="req-box">
      <h4 className="count">Count: {data?.assigned?.length}</h4>
      <p className="sub-title">Assigned Requirements</p>
      <div className="list-box">
        <input
          type="text"
          placeholder="Search"
          className="search"
          value={searchText[title]?.assigned}
          onChange={(e) => handleSearch(title, "assigned", e.target.value)}
        />
        {/* <ul>{renderList(title, "assigned", data?.assigned)}</ul> */}
        <ul ref={(el) => { if (el) listRefs.current[`${title}-assigned`] = el; }}>
        {renderList(
            title,
            "assigned",
            data?.assigned?.filter((x) =>
              x.name.toLowerCase().includes(
                (searchText[title]?.assigned || "").toLowerCase()
              )
            )
          )}
        </ul>
      </div>
    </div>
  </div>
);

const ApproveCriteria = () => {
  const navigate = useNavigate();
  const approveCriteriaRefs = useRef();
  const { id } = useParams();
  const editID = useMemo(() => (id ? decryptAESID(id, false) : 0), [id]);
  const [formData] = useState(ApproveCriteriaData);
  const [channel, setChannel] = useState(null);
  const { success, error, confirm } = SwalAlert()
  const [getAllRequirementListForSectionA] = useGetAllRequirementListForSectionAMutation();
  const [getAllRequirementListForSectionB] = useGetAllRequirementListForSectionBMutation();
  const [getAllRequirementListForSectionC] = useGetAllRequirementListForSectionCMutation();
  const [getDropdowns, { data: dropdownData, isLoading: dropdownLoading },] = useLazyGetAllDropdownForCRUDCategoryQuery();
  const [getSGBPCriteriaDetails, { data: criteriaDetails, isLoading: criteriaDetailsLoading },] = useLazyGetSGBPCriteriaDetailsByIdQuery();
  const [approveSGBPCriteria, { data: approveSGBPCriteriaData, isLoading: approveSGBPCriteriaIsLoading },] = useApproveSGBPCriteriaByIdMutation();
  const [submitCriteria, { data: criteriaData, isLoading: criteriaLoading },] = useUpdateCriteriaDetailsMutation();

  const [downloadProductCertification, { data: downloadProductCertificationData, isLoading: downloadProductCertificationLoading },] = useDDownloadProductCertificationAssessmentCritreriaMutation();
  const listRefs = useRef({});

  const preserveScroll = (key, callback) => {
    const el = listRefs.current[key];
    const scrollTop = el?.scrollTop || 0;
    callback();
    setTimeout(() => {
      if (listRefs.current[key]) {
        listRefs.current[key].scrollTop = scrollTop;
      }
    }, 0);
  };

  const [sections, setSections] = useState({
    "Section A": { approved: [], assigned: [] },
    "Section B": { approved: [], assigned: [] },
    "Section C": { approved: [], assigned: [] },
  });

  const [searchText, setSearchText] = useState({
    "Section A": { approved: "", assigned: "" },
    "Section B": { approved: "", assigned: "" },
    "Section C": { approved: "", assigned: "" },
  });

  const [ratings, setRatings] = useState({
    1: 0,
    2: 0,
    3: 0,
    4: 0,
  });


  useEffect(() => {
    getDropdowns()
  }, []);



  useEffect(() => {
    if (id) {
      getSGBPCriteriaDetails(editID);
    }
  }, [id]);

  useEffect(() => {
    if (!criteriaDetailsLoading && criteriaDetails) {
      const initialData = ApproveCriteriaData.initialState;
      initialData.channel = criteriaDetails?.channelId || criteriaDetails?.channelId?.value;
      initialData.criteriaName = criteriaDetails?.criteriaName || null;
      setChannel(criteriaDetails?.channelId);
      fetchSectionA("", criteriaDetails?.channelId);
      fetchSectionB("", criteriaDetails?.channelId);
      fetchSectionC("", criteriaDetails?.channelId);
      setRatings({
        1: criteriaDetails?.rating1Tick ?? 0,
        2: criteriaDetails?.rating2Tick ?? 0,
        3: criteriaDetails?.rating3Tick ?? 0,
        4: criteriaDetails?.rating4Tick ?? 0,
      });
    }
  }, [criteriaDetailsLoading, criteriaDetails]);

  useEffect(() => {
    if (!dropdownLoading && dropdownData) {
      setAllDropDownField(dropdownData);
    }
  }, [dropdownLoading, dropdownData]);

  useEffect(() => {
    if (!approveSGBPCriteriaIsLoading && approveSGBPCriteriaData) {
      success("Criteria information approve successfully")
      navigate("/criteriaApproval");
    }
  }, [approveSGBPCriteriaIsLoading, approveSGBPCriteriaData]);

  useEffect(() => {
    if (!criteriaLoading && criteriaData) {
      if (criteriaData?.errorMessage === "Criteria Name Already Exists.") {
        error("Criteria name already exists.")
      }
      else {
        success("Criteria information submitted successfully")
        navigate("/criteriaApproval");
      }
    }
  }, [criteriaLoading, criteriaData]);

  const fetchSection = (apiCall, section, search, channelId) => {
    (apiCall({ RequirementName: search, channelId: channelId }))
      .unwrap()
      .then((response) => {
        const approvedItems = (response || []).map((item) => ({
          id: item?.sgbpRequirementId,
          name: item?.requirementName,
          selected: false,
        }));
        setSections((prev) => {
          const requirementList = criteriaDetails?.requirementList || [];
          const sectionMap = {
            "Section A": 1,
            "Section B": 2,
            "Section C": 3,
          };

          const selectedIds = requirementList.filter(x => x.sectionId === sectionMap[section]).map(x => x.sgbpRequirementId);

          // const assigned = approvedItems.filter(item =>
          //   selectedIds?.some(id => Number(id) === Number(item.id))
          // );
          const assigned =
          prev[section]?.assigned?.length > 0
            ? prev[section].assigned
            : approvedItems.filter(item =>
                selectedIds?.some(id => Number(id) === Number(item.id))
              );
        
        const approved = approvedItems.filter(
          item => !assigned.some(x => Number(x.id) === Number(item.id))
        );

          return {
            ...prev,
            [section]: { approved, assigned },
          };
        });;
      })
      .catch((err) => console.error(err));
  };

  const fetchSectionA = (search, channelId) => fetchSection(getAllRequirementListForSectionA, "Section A", search, channelId);
  const fetchSectionB = (search, channelId) => fetchSection(getAllRequirementListForSectionB, "Section B", search, channelId);
  const fetchSectionC = (search, channelId) => fetchSection(getAllRequirementListForSectionC, "Section C", search, channelId);

  const handleSearch = (section, type, value) => {
    setSearchText((prev) => ({
      ...prev,
      [section]: { ...prev[section], [type]: value },
    }));

    if (type === "approved") {
      if (section === "Section A") fetchSectionA(value, channel);
      if (section === "Section B") fetchSectionB(value, channel);
      if (section === "Section C") fetchSectionC(value, channel);
    }
  };

  // const handleAssign = (section) => {
  //   const approved = [...sections[section].approved];
  //   const assigned = [...sections[section].assigned];

  //   const toAssign = approved.filter((item) => item.selected);
  //   if (!toAssign.length) return;

  //   const newApproved = approved.filter((item) => !item.selected);
  //   const newAssigned = [...toAssign.map(i => ({ ...i, selected: false })), ...assigned];

  //   setSections((prev) => ({
  //     ...prev,
  //     [section]: { approved: newApproved, assigned: newAssigned },
  //   }));
  // };

  // const handleUnassign = (section) => {
  //   const approved = [...sections[section].approved];
  //   const assigned = [...sections[section].assigned];

  //   const toUnassign = assigned.filter((item) => item.selected);
  //   if (!toUnassign.length) return;

  //   const newAssigned = assigned.filter((item) => !item.selected);
  //   const newApproved = [...toUnassign.map(i => ({ ...i, selected: false })), ...approved];

  //   setSections((prev) => ({
  //     ...prev,
  //     [section]: { approved: newApproved, assigned: newAssigned },
  //   }));
  //   if (section == "Section C") {
  //     setRatings({
  //       1: 0,
  //       2: 0,
  //       3: 0,
  //       4: 0,
  //     });
  //   }
  // };

  const handleAssign = (section) => {
    const key = `${section}-approved`;
    preserveScroll(key, () => {
      const approved = [...sections[section].approved];
      const assigned = [...sections[section].assigned];
      const toAssign = approved.filter((item) => item.selected);
      if (!toAssign.length) return;
      const newApproved = approved.filter((item) => !item.selected);
      const newAssigned = [...assigned,...toAssign.map(i => ({ ...i, selected: false }))];
      setSections((prev) => ({
        ...prev,
        [section]: { approved: newApproved, assigned: newAssigned },
      }));
    });
  };

  const handleUnassign = (section) => {
    const key = `${section}-assigned`;
    preserveScroll(key, () => {
      const approved = [...sections[section].approved];
      const assigned = [...sections[section].assigned];
      const toUnassign = assigned.filter((item) => item.selected);
      if (!toUnassign.length) return;
      const newAssigned = assigned.filter((item) => !item.selected);
      const newApproved = [...toUnassign.map(i => ({ ...i, selected: false })), ...approved];
      setSections((prev) => ({
        ...prev,
        [section]: { approved: newApproved, assigned: newAssigned },
      }));
      if (section == "Section C") {
        setRatings({ 1: 0, 2: 0, 3: 0, 4: 0, });
      }
    });
  };

  const scrollPositions = useRef({});

  useEffect(() => {
    const keys = Object.keys(listRefs.current);
    keys.forEach((key) => {
      const el = listRefs.current[key];
      if (!el) return;
      const handleScroll = () => { scrollPositions.current[key] = el.scrollTop; };
      el.addEventListener("scroll", handleScroll);
      return () => { el.removeEventListener("scroll", handleScroll); };
    });
  }, [sections]);



  useEffect(() => {
    Object.keys(listRefs.current).forEach((key) => {
      const el = listRefs.current[key];
      if (el && scrollPositions.current[key] !== undefined) {
        el.scrollTop = scrollPositions.current[key];
      }
    });
  });

  const toggleSelect = (section, type, id) => {
    const key = `${section}-${type}`;
    preserveScroll(key, () => {
      setSections((prev) => ({
        ...prev, [section]: {
          ...prev[section], [type]: prev[section][type].map((item) =>
            item.id === id ? { ...item, selected: !item.selected } : item
          ),
        },
      }));
    });
  };

  // const toggleSelect = (section, type, id) => {
  //   setSections((prev) => ({
  //     ...prev,
  //     [section]: {
  //       ...prev[section],
  //       [type]: prev[section][type].map((item) =>
  //         item.id === id ? { ...item, selected: !item.selected } : item
  //       ),
  //     },
  //   }));
  // };

  const handleSave = () => {
    let authData = getAuthProps();
    const formValues = approveCriteriaRefs.current?.getFormData();

    if (!formValues) {
      error("Please fill in all mandatory fields to continue.", "");
      return;
    }

    const requirementList = [
      ...sections["Section A"].assigned.map((item) => ({ SGBPRequirementId: item.id, SectionId: 1, CreatedBy: 115, CreatedAppId: authData?.adminUserId, CriteriaId: editID })),
      ...sections["Section B"].assigned.map((item) => ({ SGBPRequirementId: item.id, SectionId: 2, CreatedBy: 115, CreatedAppId: authData?.adminUserId, CriteriaId: editID })),
      ...sections["Section C"].assigned.map((item) => ({ SGBPRequirementId: item.id, SectionId: 3, CreatedBy: 115, CreatedAppId: authData?.adminUserId, CriteriaId: editID })),
    ];


    const request = {
      CriteriaId: editID,
      ChannelId: formValues?.channel?.value || formValues?.channel || null,
      CriteriaName: formValues?.criteriaName || null,
      Rating1Tick: Number(ratings[1]) ?? null,
      Rating2Tick: Number(ratings[2]) ?? null,
      Rating3Tick: Number(ratings[3]) ?? null,
      Rating4Tick: Number(ratings[4]) ?? null,
      RequuirementList: requirementList,
      StatusId: 3
    };
    submitCriteria(request);
  };


  const renderList = (section, type, list) =>
    list?.map((item) => (
      <li key={item.id}>
        <input
          type="checkbox"
          checked={item.selected || false}
          onChange={() => toggleSelect(section, type, item.id)}
        />
        <span>{item.name}</span>
      </li>
    ));



  // const minLen = sections?.["Section C"]?.assigned?.length ?? 0;
  // const total = Object.values(ratings).reduce((sum, val) => sum + val, 0);
  // const handleChange = (tick, value) => {
  //   const num = Number(value);
  //   if (isNaN(num) || num < 0) return;
  //   const currentTotal = Object.values(ratings).reduce((s, v) => s + v, 0);
  //   const newTotal = currentTotal - ratings[tick] + num;
  //   // Only block if increasing beyond limit
  //   if (num > ratings[tick] && newTotal > minLen) return;
  //   setRatings((prev) => ({
  //     ...prev,
  //     [tick]: num,
  //   }));
  // };

  const minLen = sections?.["Section C"]?.assigned?.length ?? 0;
  const handleChange = (key, value) => {
    if (!/^\d*$/.test(value)) return;

    const cleanedValue = value.replace(/^0+/, "") || "0";
    const num = Number(cleanedValue);
    // const num = Number(value);
    if (num > minLen) return;
    // const total = Object.entries(ratings).reduce((sum, [key, val]) => {
    //   if (Number(key) === Number(tick)) {
    //     return sum + num;
    //   }
    //   return sum + Number(val || 0);
    // }, 0);
    // if (total > minLen) return;

    // setRatings((prev) => ({
    //   ...prev,
    //   [tick]: num,
    // }));
       setRatings((prev) => {
      const updated = { ...prev, [key]: num };
      // Validation: enforce increasing order
      for (let i = 2; i <= 4; i++) {
        if (updated[i] !== 0 && updated[i] <= updated[i - 1]) {
          // reject update
          return prev;
        }
      }

      return updated;
    });
  };

  const handleApprove = () => {
    let req = {
      SGBPCriteriaId: editID
    }
    approveSGBPCriteria(req)

  }

  const handleBack = () => {
    navigate("/criteriaApproval");
  }

  const handleDownloadPDF = async () => {
    let requet = { SGBPCriteriaId: editID }
    let response = await downloadProductCertification(requet);

    if (response && response.data) {
      const { fileData, fileName } = response.data;
      const blob = new Blob([fileData], { type: 'application/pdf' });
      let tempfileName = 'ProductCertificate.pdf';
      saveAs(blob, tempfileName);
    }
  }
  const handleFormFieldChange = (field, value) => {
    if (field === "channel") {
      setChannel(value?.value);
      fetchSectionA("", value?.value);
      fetchSectionB("", value?.value);
      fetchSectionC("", value?.value);
      setRatings({
        1: 0,
        2: 0,
        3: 0,
        4: 0,
      });
    }
  }


  return (
    <div className="add-requirement">
      <Suspense fallback={<DataLoader />}>
        <Accordion
          title="Criteria Information"
          className="mb-4"
          button={false}
          accordion={false}
        >
          <div className="row">
            <FormCreator ref={approveCriteriaRefs} {...formData} onFormFieldValueChange={handleFormFieldChange} />
          </div>

          <div className="requirements-page">
            <Section 
            title="Section A" 
            data={sections["Section A"]} 
            searchText={searchText}
            handleSearch={handleSearch}
            renderList={renderList}
            listRefs={listRefs}
            handleAssign={handleAssign}
            handleUnassign={handleUnassign}
            />



            <Section 
            title="Section B" 
            data={sections["Section B"]}
            searchText={searchText}
            handleSearch={handleSearch}
            renderList={renderList}
            listRefs={listRefs}
            handleAssign={handleAssign}
            handleUnassign={handleUnassign}
            />


            <Section
            title="Section C" 
            data={sections["Section C"]}  
            searchText={searchText}
            handleSearch={handleSearch}
            renderList={renderList}
            listRefs={listRefs}
            handleAssign={handleAssign}
            handleUnassign={handleUnassign}
            />
          </div>
          <div className="sectionC-info">
            <div className="sectionC-header">
              <h3>Section C Additional Information</h3>
            </div>

            <div className="rating-container">
              <p className="rating-title">Rating</p>
              {[1, 2, 3, 4].map((tick) => (
                <div className="rating-row" key={tick}>
                  <span className="rating-label">{tick} Tick</span>
                  <input
                    type="text"
                    className="rating-input"
                    value={minLen == 0 ? "" : ratings[tick]}
                    // disabled={total >= minLen && ratings[tick] == 0}
                    onChange={(e) => handleChange(tick, e.target.value)}
                  />

                  <span className="rating-total">/{minLen || "N.A"}</span>
                </div>
              ))}
            </div>
          </div>
        </Accordion>
        <div className="add-criteria-btn-wrapper">
          <Buttons
            buttonText="Back"
            buttonTypeClassName="btn btn-secondary mb-2"
            onClick={handleBack}
          />
          <Buttons
            buttonText="Download PDF"
            buttonTypeClassName="orange-btn"
            onClick={handleDownloadPDF}
            isDisable={criteriaDetails?.statusId != 9 || downloadProductCertificationLoading}
            isLoading={downloadProductCertificationLoading}
          />
          <Buttons
            buttonText="Save"
            buttonTypeClassName="add-btn"
            onClick={handleSave}
            isDisable={criteriaDetails?.statusId == 9}
          />
          <Buttons
            buttonText="Approve"
            buttonTypeClassName="approve-btn"
            onClick={handleApprove}
            isDisable={criteriaDetails?.statusId == 9}

          />
        </div>
      </Suspense>
    </div>
  );
};

export default ApproveCriteria;
